import React from 'react';
import { Link } from 'react-router';
import classNames from 'classnames/bind';
import moment from 'moment';
import { withTranslation } from 'react-i18next';

import styles from './WeekDayPicker.scss';


const cx = classNames.bind(styles);

// const propTypes = {
//   day: React.PropTypes.object.isRequired,
// };

const defaultProps = {
};

class WeekDayPicker extends React.Component {
  renderDays() {
    // this.props.day явлется обьектом moment
    const { day, t } = this.props;

    const weekdays = [];
    for (let i = 0; i < 7; i += 1) {
      const weekday = day.weekday(i);
      const dayNames = [
        t('Monday'),
        t('Tuesday'),
        t('Wednesday'),
        t('Thursday'),
        t('Friday'),
        t('Saturday'),
        t('Sunday'),
      ];
      const isToday = weekday.isSame(moment(), 'day');
      const link = (
        <Link
          key={i}
          to={`/children/${weekday.format('YYYY-MM-DD')}`}
          className={styles.link}
          activeClassName={styles.active}
        >
          <div className={styles.container}>
            <div className={cx({ h1: true, today: isToday })}>
              {dayNames[i]}
            </div>
            <div className={styles.h2}>
              {day.format('DD.MM')}
            </div>
          </div>
        </Link>
      );

      weekdays.push(link);
    }
    return weekdays;
  }

  render() {
    const {
      day, // eslint-disable-line no-unused-vars
      i18n, // eslint-disable-line no-unused-vars
      t, // eslint-disable-line no-unused-vars
      tReady, // eslint-disable-line no-unused-vars
      ...props
    } = this.props;

    return (
      <div className={styles.main} {...props}>
        {this.renderDays()}
      </div>
    );
  }
}

// WeekDayPicker.propTypes = propTypes;
WeekDayPicker.defaultProps = defaultProps;

export default withTranslation('children')(WeekDayPicker);
